import type { IncidentContextI } from '../types/incidentContextTypes'

export const buildIncidentContext = (
  incident: {
    id?: string
    type?: string
    displayId?: string
    facility?: { id?: string; name?: string } | null
    floor?: { name?: string } | null
  },
  device?: { type?: string; name?: string } | null
): IncidentContextI => ({
  facility_id: incident.facility?.id ?? '',
  facility_name: incident.facility?.name ?? '',
  floor_name: incident.floor?.name ?? '',
  device_type: device?.type ?? '',
  device_name: device?.name ?? '',
  incident_id: incident.id ?? '',
  incident_type: incident.type ?? '',
  display_id: incident.displayId ?? '',
})
